
const AccountSettingsDrawer = () => {
    return (
        <div></div>
    )
};

export default AccountSettingsDrawer;